import { routes } from '../routes';
import { hasPermissionToNavItem } from '../utils/permissions';

function getNavDrawerItems() {
    let navItems = [];
    let previousPath = '';
    for (let route of routes) {
        if (route.meta?.navDrawerItem) {
            if (previousPath && route.path.indexOf(previousPath) === 0) {
                if (!Array.isArray(navItems[navItems.length - 1].items)) {
                    navItems[navItems.length - 1].items = [];
                }
                navItems[navItems.length - 1].items.push(route);
            } else {
                previousPath = route.path;
                navItems.push(Object.assign({}, route));
            }
        }
    }
    let test = routesToNavItem(navItems);
    return test;
}

function routesToNavItem(routeArray) {
    return routeArray.map((route) => {
        let navItem = {
            title: route.meta.navDrawerItem?.title,
            icon: route.meta.navDrawerItem?.icon,
            ingroups: route.meta.ingroups,
            permissions: route.meta.permissions,
            permissionsAny: route.meta.permissionsAny,
            noNavLink: route.meta.navDrawerItem?.noNavLink,
            items: [],
        };
        if (Array.isArray(route.items) && route.items.length > 0) {
            navItem.items = routesToNavItem(route.items);
        }
        if (!navItem.noNavLink) {
            navItem.to = route.path;
        }
        return navItem;
    });
}
function getIngroupPaths(userIngroup) {
    let paths = [];
    for (let route of routes) {
        if (!route.meta?.ingroups) {
            paths.push(route.path);
        } else if (route.meta.ingroups.includes(userIngroup.toUpperCase())) {
            paths.push(route.path);
        }
    }
    return paths;
}
function filterItemsByIngroup(userIngroup, navItems) {
    let test = navItems.filter((item) => {
        if (item.items) {
            item.items = filterItemsByIngroup(userIngroup, item.items);
        }
        if (!item.ingroups) {
            return hasPermissionToNavItem(item);
        } else if (item.ingroups.includes(userIngroup.toUpperCase())) {
            return hasPermissionToNavItem(item);
        }
    });
    return test;
}
function getNavigationItems(userIngroup) {
    return filterItemsByIngroup(userIngroup, getNavDrawerItems());
}
export { filterItemsByIngroup, getNavigationItems, getIngroupPaths };
